// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3HKq7","title":"Images45_title__2CYKn","images":"Images45_images__IFc4A"};